var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 24,
    viewBox: "0 0 61 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1318_4438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8626 17.9635C34.387 16.5446 35.1427 15.2336 36.1298 14.0306C36.1298 13.9997 36.1298 13.9843 36.1298 13.9843C36.3766 13.645 36.6233 13.3057 36.8701 12.9664C37.7955 11.64 38.2736 10.0977 38.3045 8.33942C38.2428 6.02595 37.4408 4.11347 35.8984 2.602C34.387 1.05968 32.4745 0.257679 30.161 0.195986C27.8475 0.257679 25.9351 1.05968 24.4236 2.602C22.8813 4.11347 22.0793 6.02595 22.0176 8.33942C22.0484 10.0977 22.5265 11.64 23.4519 12.9664C23.6987 13.3057 23.9455 13.6296 24.1922 13.938C24.1922 13.9689 24.1922 13.9843 24.1922 13.9843C25.1793 15.1873 25.9351 16.5137 26.4595 17.9635H33.8626ZM30.161 23.886C31.2098 23.8551 32.0889 23.5004 32.7984 22.8218C33.477 22.1123 33.8317 21.2332 33.8626 20.1844V19.4441H26.4595V20.1844C26.4903 21.2332 26.845 22.1123 27.5237 22.8218C28.2331 23.5004 29.1122 23.8551 30.161 23.886ZM26.4595 8.33942C26.4286 8.80212 26.1818 9.04889 25.7191 9.07974C25.2564 9.04889 25.0097 8.80212 24.9788 8.33942C25.0097 6.8588 25.5186 5.64037 26.5057 4.68413C27.462 3.69705 28.6804 3.18808 30.161 3.15724C30.6237 3.18808 30.8705 3.43485 30.9013 3.89755C30.8705 4.36024 30.6237 4.60701 30.161 4.63786C29.1122 4.66871 28.2331 5.02344 27.5237 5.70206C26.845 6.41153 26.4903 7.29065 26.4595 8.33942Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1318_4438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 23.69,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.161133 23.886)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.610c8256affcff5fb7c3f07c12453011.svg";
export { ForwardRef as ReactComponent };